import React from "react";
import "./Home.css";

export default function Home() {
  return (
    <div className="Home">
      <div className="lander">
        <h1>Grainstore UI</h1>
        <p>A simple UI for querying Grainstore Data</p>
      </div>
    </div>
  );
}